import React, { useState, useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';


function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showResetForm, setShowResetForm] = useState(false);
  const [resetEmail, setResetEmail] = useState('');
  const [resetMessage, setResetMessage] = useState('');
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const success = await login(email, password);
    if (success) {
      navigate('/');
    } else {
      setError('Email o contraseña incorrectos');
    }
  };

  const handlePasswordResetRequest = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post(`password-reset-request/`, { email: resetEmail });
      setResetMessage(response.data.message);
      setResetEmail('');
    } catch (error) {
      setResetMessage('Error al enviar la solicitud. Intenta de nuevo.');
    }
  };

  return (
    <div className="page login">
      <h2>Iniciar sesión</h2>
      {!showResetForm ? (
        <>
          <form onSubmit={handleSubmit}>
            <div>
              <label>Email:</label>
              <input
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div>
              <label>Contraseña:</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            {error && <p style={{ color: 'red' }}>{error}</p>}
            <button type="submit">Entrar</button>
          </form>
          <p>
          <button
              type="button"
              onClick={() => setShowResetForm(true)}
              style={{
                background: 'none',
                border: 'none',
                color: '#4CAF50',
                cursor: 'pointer',
                textDecoration: 'underline',
                padding: 0,
              }}
            >
              ¿He olvidado mi contraseña?
            </button>
          </p>
        </>
      ) : (
        <>
          <h3>Recuperar contraseña</h3>
          <form onSubmit={handlePasswordResetRequest}>
            <div>
              <label>Email:</label>
              <input
                type="text"
                value={resetEmail}
                onChange={(e) => setResetEmail(e.target.value)}
                required
              />
            </div>
            {resetMessage && <p style={{ color: 'green' }}>{resetMessage}</p>}
            <button type="submit">Enviar enlace de recuperación</button>
          </form>
          <p>
          <button
              type="button"
              onClick={() => setShowResetForm(false)}
              style={{
                background: 'none',
                border: 'none',
                color: '#4CAF50',
                cursor: 'pointer',
                textDecoration: 'underline',
                padding: 0,
              }}
            >
              Volver al login
            </button>
          </p>
        </>
      )}
    </div>
  );
}

export default Login;